<template>
  <div class="base-foot common-box">
    <div class="info">
      <div class="width1460 flex justify-between">
        <div class="foot-item">
          <div class="title">联系我们</div>
          <div class="address">地址：陕西省渭南市白水县尧禾镇尧禾街南段</div>
<!--          <div class="phone">-->
<!--           <span>联系电话：0913****299</span>-->
<!--            <span>邮编：715601</span>-->
<!--          </div>-->
        </div>
<!--        <div class="foot-item flex">-->
<!--          <div class="code-box">-->
<!--            <div class="title">大贤·电商平台</div>-->
<!--            <div class="code-wrapper flex">-->
<!--              <div class="code-item">-->
<!--                <div></div>-->
<!--                <div>小程序</div>-->
<!--              </div>-->
<!--              <div class="code-item">-->
<!--                <div></div>-->
<!--                <div>APP</div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="code-box">-->
<!--            <div class="title">大贤·新媒体矩阵</div>-->
<!--            <div class="code-wrapper flex">-->
<!--              <div class="code-item">-->
<!--                <div></div>-->
<!--                <div>公众号</div>-->
<!--              </div>-->
<!--              <div class="code-item">-->
<!--                <div></div>-->
<!--                <div>抖音</div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
    <div class="copyright">
      <a style="color: #fff" href="https://beian.miit.gov.cn/" target="_blank">ICP备案号 陕ICP备2025074829号-1</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "baserFooter"
}
</script>



<style scoped lang="less">
.base-foot{
  .info{
    background-color: #80512E;
    padding: 50px 0;
    .foot-item{
      color: #fff;
      font-size: 16px;
      .code-box{
        margin-right: 171px;
      }
      .title{
        font-size: 24px;
        font-weight: bold;
      }
      .address{
        margin: 35px 0 15px;
      }
      .code-box{
        .title{
          text-align: center;
        }
        .code-wrapper{
          margin-top: 30px;
        }
        .code-item{
          width: 78px;
          margin-right: 16px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          &:last-child{
            margin-right: 0;
          }
          div:first-child{
            width: 78px;
            height: 78px;
            margin-bottom: 10px;
            background-color: #fff;
          }

        }
      }
    }
  }
  .copyright{
    height: 53px;
    background-color: #55131D;
    font-size: 12px;
    color: #fff;
    text-align: center;
    line-height: 53px;
  }
}
</style>
